import React, { useEffect, useState } from "react";

import "./manageUser.scss";
import "./src/components/card/card.scss";


import User from "assets/images/adduser/Add User Icon.svg";
// import upload from "assets/images/adduser/Import Icon.svg";
import rightArrow from "../../../../assets/images/homepage/setting/ManageUser/rightArrow.svg";
import rightArrowDark from "../../../../assets/images/homepage/setting/ManageUser/rightArrowDark.svg";
import nodata from "assets/images/homepage/setting/No data.svg";
import useTheme from "hooks/observer";
import ReusableModal from "components/ReusableModal/index";
import Card from "components/Card/index";
import MultipleUserModal from "components/UserFormModal/MultipleUserModal/index";
import DeleteModal from "components/DeleteModal/index";
// import init, { IzWasm } from "Wasm/izwasm.js";
import { useToast } from "components/Toaster/index";
// import { URL } from "URL/url";
import ManageUserTable from "./ManageUserTable/ManageUserTable";
import UserContent from "./UserContent/UserContent";
import ManageUserList from "./ManageUserList/index";
import EmptyUser from "./UserContent/CreateUser/EmptyUser";
import { ManageUser as MU } from "@induz/sdk";

function ManageUser({ setManageUser, searchQuery, setSearchQuery }) {
  // const deviceData = [
  //   { id: 1, name: "Oliver Twist", email: "johndoe@gmail.com" },
  //   { id: 2, name: "Alexander Finch", email: "johndoe@gmail.com" },
  //   { id: 3, name: "Sophia Turner", email: "johndoe@gmail.com" },
  //   { id: 4, name: "Isabella Monroe", email: "johndoe@gmail.com" },
  //   { id: 5, name: "Maxwell Carter", email: "johndoe@gmail.com" }
  // ];
  // console.log(deviceData);
  const theme = useTheme();
  const [editModal, setEditModal] = useState(false);
  const [editModalList, setEditModalList] = useState(false);
  // const [deletModal, setDeleteModal] = useState(false);
  // const isMobile = useScreenMobile({ size: 768 }); // Removed - no longer used
  // const [roleToDeleteIndex, setRoleToDeleteIndex] = useState(null);
  // const [searchQuery, setSearchQuery] = useState(""); // Now using props from homepage
  const [, setFilteredList] = useState([]);
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showSingleUserModal, setShowSingleUserModal] = useState(false);
  const [showMultipleUserModal, setShowMultipleUserModal] = useState(false);
  const [userList, setUserList] = useState([]); // Added users list data
  const [showUserList, setShowUserList] = useState(false);
  const [userIndex, setUserIndex] = useState(null);
  const [editableUser, setEditableUser] = useState({});
  const [listName, setListName] = useState("singleUser");
  const [showdelete, setShowdelete] = useState(false);
  const [csvList, setCsvList] = useState([]);

  const showToast = useToast();

  useEffect(() => {

  }, [editModal]);

  const deleteuser = async () => {
    setShowdelete(false);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler); // Cleanup timeout on every keystroke
    };
  }, [searchQuery]);

  // Effect to update filtered list when debouncedQuery changes
  useEffect(() => {
    setFilteredList(
      userList.filter((item) =>
        item.name.toLowerCase().includes(debouncedQuery.toLowerCase())
      )
    );
  }, [debouncedQuery]);

  const addUserHandler = () => {
    // Show popup
    setShowAddUserModal(true);
  };

  // Register the invite handler with the homepage
  useEffect(() => {
    window.inviteUsersHandler = addUserHandler;
    
    // Cleanup on unmount
    return () => {
      window.inviteUsersHandler = null;
    };
  }, []);

  const validate = (name, email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let error = "";
    if (name === "" || email === "") {
      error = true;
    } else if (name?.length < 2) {
      error = true;
    } else if (!emailRegex.test(email)) {
      error = true;
    }

    return error ? "Error" : "Success";
  };

  const deleteUser = (index) => {
    // Delete individual user
    const userListCopy = structuredClone(csvList);
    const filteredUserList = userListCopy.filter((_, ind) => ind !== index);
    setCsvList(filteredUserList);
  };

  const hasErrors = csvList?.some(
    (item) => validate(item.name, item.email) !== "Success"
  );

  const editUser = (index) => {
    // To edit user details in upload
    setUserIndex(index);
    const userListCopy = structuredClone(csvList);
    const particularUser = userListCopy.find((_, ind) => index === ind);
    setEditableUser(particularUser);
  };

  const multipleUserEditSubmit = (e) => {
    // Update user details in upload file
    const userListCopy = structuredClone(csvList); // Deep copy of userList
    // Update the user at the given index
    const updatedUserList = userListCopy.map((item, ind) => {
      return ind === userIndex
        ? { ...item, name: editableUser.name, email: editableUser.email }
        : item;
    });
    setCsvList(updatedUserList);
    setEditModal(false);
  };

  const addToAccountHandler = async () => {

    if (!csvList.length) {
      showToast("No users to add. Please upload a valid CSV file.", "error");
      return;
    }

    // await init();
    // const wasmInstance = new IzWasm(URL);
    // const mailIds = csvList.map((user) => user.email);
    // const type = csvList.map(() => "user");
    // try {
    //   console.log("Inviting users:", mailIds);
    //   const org = await wasmInstance.invite_users(mailIds, "org", type);
    //   console.log("API response:", org);

    //   if (org) {
    // Filter out duplicates and create new roles
    const newRoles = csvList
      .filter((user) => !roles.some((role) => role.email === user.email))
      .map((user) => ({
        name: user.name,
        email: user.email,
        role: [""], // Default role
        team: [""] // Default team
      }));



    // Update roles state
    setRoles((prevRoles) => {
      const updatedRoles = [...prevRoles, ...newRoles];

      return updatedRoles;
    });

    // Reset csvList and close modal
    setCsvList([]);
    setShowUserList(false);
    showToast("Users successfully added to account!", "success");
    //   } else {
    //     throw new Error("API returned falsy response");
    //   }
    // } catch (error) {
    //   console.error("Error in addToAccountHandler:", error);
    //   showToast(`Failed to add users: ${error.message}`, "error");
    // }
  };

  useEffect(() => {
    if (userList.length === 0 && csvList.length === 0) {
      setShowUserList(false);
    }
  }, [userList, csvList]);

  const reuploadHandler = () => {
    setShowUserList(false);
    setShowMultipleUserModal(true);
  };

  const getUsers = async () => {
    try {
      const userList = await MU.listUsers(); //


      const formattedData = userList.map((user) => ({
        name: "",
        email: user.email,
        isBlocked: user.isBlocked,
        role: user.roles.map((item) => { return item; }), // Default to empty array if no roles
        team: user.teams.map((item) => { return item; }) // Default to empty array if no teams
      }));

      setRoles(formattedData);
      setFilteredRoles(formattedData);

    } catch (error) {
      console.error("Error during list users:", error);
    }
  };

  // const getOrg = async () => {
  //   try {
  //     await init();
  //     const wasmInstance = new IzWasm(URL);
  //     const org = await wasmInstance.get_orgnization(
  //       localStorage.getItem("mail"),
  //       "org"
  //     );
  //     console.log("org name", org.org_name());
  //   } catch (error) {
  //     console.error("Error during get_organization:", error);
  //   }
  // };

  useEffect(() => {
    getUsers();
    // getOrg();
  }, []);

  // @TODO : Updated Flow Started From Here

  const initialRoles = [
    // {
    //   name: "Alice Johnson",
    //   email: "alice.johnson@example.com",
    //   role: ["Admin", "Editor"],
    //   team: ["Design Team", "Dev Team"]
    // },
    // {
    //   name: "Bob Smith",
    //   email: "bob.smith@example.com",
    //   role: ["Viewer"],
    //   team: ["Marketing Team"]
    // }
  ];

  const [roles, setRoles] = useState(initialRoles);
  const [filteredRoles, setFilteredRoles] = useState(roles);

  const [selectedRow, setSelectedRow] = useState(null);
  const [, setSelectedIndex] = useState("");

  useEffect(() => {
    const filtered = roles.filter((role) =>
      role.email.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredRoles(filtered);
  }, [searchQuery, roles]);

  const handleModal = () => {
    setShowSingleUserModal(false);
    setShowMultipleUserModal(false);
    setEditModal(false);
  };

  // add the user here
  const handleAddRole = async (newRole) => {
    if (editModal) {
      handleUpdatedata(newRole);
    }
    setRoles((prev) => [
      ...prev,
      {
        name: newRole.name,
        email: newRole.email,
        role: newRole.roles,
        team: newRole.teams
      }
    ]);
    await MU.inviteUsersList(newRole.email);
  };

  // handling the Update the Data
  const handleUpdatedata = async (newRole) => {
    const correctedRole = {
      ...newRole,
      role: newRole.roles,
      team: newRole.teams
    };

    try {
      // Normalize roleList and teamList
      const roleList = correctedRole.role?.map(item => typeof item === "string" ? item : item.role);
      const teamList = correctedRole.team?.map(item => typeof item === "string" ? item : item.team);
      await MU.updateUser(correctedRole.email, roleList, teamList);
      await getUsers();
      setEditModal(false);
    } catch (error) {
      console.error("Error updating user:", error);
      showToast("Failed to update user", "error");
    }
  };


  // open the edit popup
  const handleEditRole = (role, index) => {
    setSelectedRow(role);
    setSelectedIndex(index);
    setEditModal(true);
  };

  // open the delete pop and store index
  // const handleDeleteRole = (index) => {
  //   setDeleteModal(true);
  //   setRoleToDeleteIndex(index);
  // };

  // deleting the row data
  // const handleDeleteRoleData = () => {
  //   const updatedRoles = roles.filter((_, i) => i !== roleToDeleteIndex);
  //   // wasm code to delete user


  //   const org = Sdk.get_signin_org();
  //   org.delete_users([roles[roleToDeleteIndex].email]);
  //   console.log("Deleted user:", roles[roleToDeleteIndex].email);


  //   setRoles(updatedRoles);
  // setDeleteModal(false);
  // };

  return (
    <div className="ManageUser">
      <div className="manageUserHeader">
        <p onClick={() => setManageUser("")} style={{ cursor: "pointer" }}>
          Settings
        </p>
        <img
          src={theme === "light" ? rightArrow : rightArrowDark}
          alt="arrow"
        />
        <p className="user">Manage Users</p>
      </div>
      {roles?.length >= 0 ? (
        <>
          <div className="title">
            {/* <p>Manage Users</p> */}
          </div>
          <div className="searchBox">
            {/* Search bar and Invite Users button moved to homepage header */}
          </div>
          <div className="manageUserTable">
            {filteredRoles?.length === 0 ? (
              <div className="empty">
                <img src={nodata} alt="no data" />
                <p className="text">No Data Found</p>
              </div>
            ) : (
              <ManageUserTable
                roles={filteredRoles}
                handleEditRole={handleEditRole}
                refreshUsers={getUsers}
              // handleDeleteRole={handleDeleteRole}
              />
            )}
          </div>
        </>
      ) : (
        <EmptyUser handleCreateUser={addUserHandler} />
      )}
      {/* Mobile Invite Users button moved to homepage header */}

      {showSingleUserModal && (
        <UserContent
          handleCancel={handleModal}
          onAddRole={handleAddRole}
          handleUpdatedata={handleUpdatedata}
          onInviteSuccess={getUsers}
        />
      )}

      {editModal && (
        <UserContent
          handleUpdatedata={handleUpdatedata}
          editModal={editModal}
          selectedRow={selectedRow}
          handleCancel={handleModal}
          onAddRole={handleAddRole}
          onInviteSuccess={getUsers}
        />
      )}

      {/* {deletModal && (
        <DeleteModal
          content={
            "Are you sure you want to permanently delete this user? This action cannot be undone."
          }
          handleCancel={() => {
            setDeleteModal(false);
            setRoleToDeleteIndex("");
          }}
          handleSave={handleDeleteRoleData}
          showHeader={false}
          submitBtnText="Ungroup"
        />
      )} */}

      {showAddUserModal && (
        <ReusableModal>
          <div className="userModal">
            <div className="cross" onClick={() => setShowAddUserModal(false)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clipPath="url(#clip0_3205_115498)">
                  <path
                    d="M18 6L6 18"
                    stroke={theme === "light" ? "#211D25" : "#FFF"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 6L18 18"
                    stroke={theme === "light" ? "#211D25" : "#FFF"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3205_115498">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="titleContainer">
              <h4 className="titleText">Invite user in your organisation</h4>
              <p className="Content">Effortlessly  invite and manage users</p>
            </div>
            <div className="cardContainer">
              <Card
                title="Invite user manually"
                content="Create user accounts individually"
                image={User}
                alt="user"
                onOpen={() => {
                  setShowSingleUserModal(true);
                  setShowAddUserModal(false);
                }}
              />
              {/* <Card
                title="Import multiple users"
                content="Upload a file to quickly add multiple users at once."
                image={upload}
                alt="upload"
                onOpen={() => {
                  setShowMultipleUserModal(true);
                  setShowAddUserModal(false);
                }}
              /> */}
            </div>
          </div>
        </ReusableModal>
      )}

      {showMultipleUserModal && (
        <MultipleUserModal
          title="Import Multiple Users"
          description="The column format must match the sample file for the data to fetch properly. Please refer to the sample file."
          setMultipleUserModal={setShowMultipleUserModal}
          setUserlist={setCsvList}
          setState={setShowUserList}
          setListName={setListName}
        />
      )}

      {showUserList && (
        <ManageUserList
          userList={userList}
          csvList={csvList}
          validate={validate}
          deleteUser={deleteUser}
          editUser={editUser}
          setEditModal={setEditModalList}
          setUserIndex={setUserIndex}
          listName={listName}
          reuploadHandler={reuploadHandler}
          addToAccountHandler={addToAccountHandler}
          hasErrors={hasErrors}
          editModal={editModalList}
          editableUser={editableUser}
          setEditableUser={setEditableUser}
          multipleUserEditSubmit={multipleUserEditSubmit}
          setUserList={setUserList}
          setShowUserList={setShowUserList}
        />
      )}
      {showdelete && (
        <DeleteModal
          title="Are you sure you want to permanently delete this user?"
          content="Delete User"
          handleCancel={() => setShowdelete(false)}
          handleSave={deleteuser}
        />
      )}
    </div>
  );
}

export default ManageUser;
